import {
  ShellIconBuilding,
  ShellIconClipboardList,
  ShellIconLayers,
  ShellIconLock,
  ShellIconPackage,
  ShellIconTag,
  ShellIconUser,
  ShellIconUsers,
  ShellIconWrench,
} from '@zrsystem/ui';

import { appPaths } from '@/app/router/paths.js';
import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

/** ADMIN_NAV_MODEL — Entidades + Acessos (users/profiles). */
export const PLATFORM_NAV_ENTRIES: readonly ShellNavEntry[] = [
  {
    kind: 'group',
    id: 'platform-entities',
    label: 'Entidades',
    icon: ShellIconBuilding,
    matchPrefix: appPaths.adminOrganizations,
    defaultPath: appPaths.adminOrganizations,
    children: [
      {
        kind: 'route',
        id: 'platform-organizations',
        label: 'Organizações',
        icon: ShellIconBuilding,
        path: appPaths.adminOrganizations,
        matchPrefix: appPaths.adminOrganizations,
      },
      {
        kind: 'route',
        id: 'platform-places',
        label: 'Oficinas',
        icon: ShellIconWrench,
        path: appPaths.adminPlaces,
        matchPrefix: appPaths.adminPlaces,
      },
      {
        kind: 'route',
        id: 'platform-networks',
        label: 'Redes',
        icon: ShellIconLayers,
        path: appPaths.adminNetworks,
        matchPrefix: appPaths.adminNetworks,
      },
    ],
  },
  {
    kind: 'group',
    id: 'platform-catalog-global',
    label: 'Catálogo global',
    icon: ShellIconTag,
    matchPrefix: appPaths.adminCatalogGlobal,
    defaultPath: appPaths.adminCatalogGlobal,
    children: [
      {
        kind: 'route',
        id: 'platform-catalog-global-base',
        label: 'Base global',
        icon: ShellIconPackage,
        path: appPaths.adminCatalogGlobal,
        matchPrefix: appPaths.adminCatalogGlobal,
      },
      {
        kind: 'route',
        id: 'platform-catalog-global-curation',
        label: 'Curadoria',
        icon: ShellIconClipboardList,
        path: appPaths.adminCatalogGlobalCuration,
        matchPrefix: appPaths.adminCatalogGlobalCuration,
      },
      {
        kind: 'route',
        id: 'platform-catalog-taxonomy',
        label: 'Taxonomia',
        icon: ShellIconLayers,
        path: appPaths.adminCatalogTaxonomy,
        matchPrefix: appPaths.adminCatalogTaxonomy,
      },
      {
        kind: 'route',
        id: 'platform-catalog-generic',
        label: 'Produtos genéricos',
        icon: ShellIconPackage,
        path: appPaths.adminCatalogGeneric,
        matchPrefix: appPaths.adminCatalogGeneric,
      },
      {
        kind: 'route',
        id: 'platform-catalog-generic-services',
        label: 'Serviços genéricos',
        icon: ShellIconPackage,
        path: appPaths.adminCatalogGenericServices,
        matchPrefix: appPaths.adminCatalogGenericServices,
      },
      {
        kind: 'route',
        id: 'platform-catalog-manufacturers',
        label: 'Fabricantes',
        icon: ShellIconTag,
        path: appPaths.adminCatalogManufacturers,
        matchPrefix: appPaths.adminCatalogManufacturers,
      },
      {
        kind: 'route',
        id: 'platform-geo-cities',
        label: 'Cidades',
        icon: ShellIconBuilding,
        path: appPaths.adminGeoCities,
        matchPrefix: appPaths.adminGeoCities,
      },
    ],
  },
  {
    kind: 'group',
    id: 'platform-access',
    label: 'Acessos',
    icon: ShellIconLock,
    matchPrefix: appPaths.adminUsers,
    defaultPath: appPaths.adminUsers,
    children: [
      {
        kind: 'route',
        id: 'platform-users',
        label: 'Usuários',
        icon: ShellIconUsers,
        path: appPaths.adminUsers,
        matchPrefix: appPaths.adminUsers,
      },
      {
        kind: 'route',
        id: 'platform-profiles',
        label: 'Perfis',
        icon: ShellIconUser,
        path: appPaths.adminProfiles,
        matchPrefix: appPaths.adminProfiles,
      },
    ],
  },
] as const;
